/* yerba-magic-cod-bridge.js
   Conecta los CTA propios del kit con el formulario COD de Releasit.

   Por que existe: las secciones del kit traen sus propios botones marcados con
   [data-buy-cta] y #bundle-cta-btn. El kit intenta abrir el form con
   window._rsiV2.setState(...), una API que ESTA VERSION de Releasit no expone,
   y su fallback hace click en '[data-buy-cta]' — es decir, en si mismo.
   Resultado: los botones no hacen nada.

   Aca interceptamos el click en fase de captura (antes que el handler del kit)
   y disparamos el boton real de Releasit (._rsi-buy-now-button), que es el que
   abre el formulario.
*/
(function () {
  'use strict';

  function releasitButton() {
    var btns = document.querySelectorAll('._rsi-buy-now-button');
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (b.offsetParent !== null && b.getBoundingClientRect().height > 0) return b;
    }
    return btns.length ? btns[0] : null;
  }

  function openCodForm() {
    var b = releasitButton();
    if (b) { b.click(); return true; }
    // Releasit todavia no monto su boton: reintentar un momento
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var btn = releasitButton();
      if (btn) { clearInterval(t); btn.click(); }
      else if (tries > 20) { clearInterval(t); }
    }, 250);
    return false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-buy-cta], #bundle-cta-btn') : null;
    if (!t) return;
    if (t.closest('._rsi-buy-now-button')) return;   // no interceptar a Releasit
    e.preventDefault();
    e.stopPropagation();
    openCodForm();
  }, true);  // captura: corre antes del handler roto del kit
})();
